/* unplugin-vue-components disabled */import { render } from "./VariantCheckbox.vue?vue&type=template&id=10ad3cab&scoped=true&ts=true"
import script from "./VariantCheckbox.vue?vue&type=script&lang=ts"
export * from "./VariantCheckbox.vue?vue&type=script&lang=ts"

import "./VariantCheckbox.vue?vue&type=style&index=0&id=10ad3cab&lang=scss&scoped=true"
import "./VariantCheckbox.vue?vue&type=style&index=1&id=10ad3cab&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ad3cab"]])

export default __exports__